export default "__VITE_ASSET__97a82d9b__"